import { useMemo } from "react";
import { DEFAULT_MAIN_MENU_NAV_THEMES, DEFAULT_MAIN_MENU_SEARCH_DIALOG_THEMES, DEFAULT_MAIN_MENU_SEARCH_INPUT_THEMES, DEFAULT_MAIN_MENU_SUBMENU_THEMES } from "../../themes.js";
const getMainMenuThemes = ({ customThemes })=>{
    const mergedNavThemes = {
        light: {
            ...DEFAULT_MAIN_MENU_NAV_THEMES.light,
            ...customThemes?.light?.nav,
            logo: {
                ...DEFAULT_MAIN_MENU_NAV_THEMES.light.logo,
                ...customThemes?.light?.nav?.logo
            }
        },
        dark: {
            ...DEFAULT_MAIN_MENU_NAV_THEMES.dark,
            ...customThemes?.dark?.nav,
            logo: {
                ...DEFAULT_MAIN_MENU_NAV_THEMES.dark.logo,
                ...customThemes?.dark?.nav?.logo
            }
        }
    };
    const mergedSubmenuThemes = {
        light: {
            ...DEFAULT_MAIN_MENU_SUBMENU_THEMES.light,
            ...customThemes?.light?.submenu
        },
        dark: {
            ...DEFAULT_MAIN_MENU_SUBMENU_THEMES.dark,
            ...customThemes?.dark?.submenu
        }
    };
    return {
        light: {
            nav: mergedNavThemes.light,
            submenu: mergedSubmenuThemes.light,
            searchInput: {
                ...DEFAULT_MAIN_MENU_SEARCH_INPUT_THEMES.light,
                ...customThemes?.light?.searchInput
            },
            searchDialog: {
                ...DEFAULT_MAIN_MENU_SEARCH_DIALOG_THEMES.light,
                backgroundColorClassName: mergedSubmenuThemes.light.backgroundColorClassName,
                textColorClassName: mergedSubmenuThemes.light.textColorClassName,
                dividerColorClassName: mergedSubmenuThemes.light.dividerColorClassName,
                ...customThemes?.light?.searchDialog
            },
            searchOverlay: {
                backgroundColorClassName: mergedNavThemes.light.backgroundColorClassName,
                textColorClassName: mergedNavThemes.light.textColorClassName,
                dividerColorClassName: mergedNavThemes.light.dividerColorClassName,
                ...customThemes?.light?.searchOverlay
            }
        },
        dark: {
            nav: mergedNavThemes.dark,
            submenu: mergedSubmenuThemes.dark,
            searchInput: {
                ...DEFAULT_MAIN_MENU_SEARCH_INPUT_THEMES.dark,
                ...customThemes?.dark?.searchInput
            },
            searchDialog: {
                ...DEFAULT_MAIN_MENU_SEARCH_DIALOG_THEMES.dark,
                backgroundColorClassName: mergedSubmenuThemes.dark.backgroundColorClassName,
                textColorClassName: mergedSubmenuThemes.dark.textColorClassName,
                dividerColorClassName: mergedSubmenuThemes.dark.dividerColorClassName,
                ...customThemes?.dark?.searchDialog
            },
            searchOverlay: {
                backgroundColorClassName: mergedNavThemes.dark.backgroundColorClassName,
                textColorClassName: mergedNavThemes.dark.textColorClassName,
                dividerColorClassName: mergedNavThemes.dark.dividerColorClassName,
                ...customThemes?.dark?.searchOverlay
            }
        }
    };
};
const useMainMenuTheme = ({ customThemes, theme = 'light', isTransparent, searchOverlayIsOpen })=>{
    const themes = useMemo(()=>getMainMenuThemes({
            customThemes
        }), [
        customThemes
    ]);
    if ('string' == typeof theme) return {
        theme: themes[theme],
        themeName: {
            nav: theme,
            submenu: theme,
            searchInput: theme,
            searchDialog: theme,
            searchOverlay: theme
        }
    };
    const searchOverlayThemeName = theme.searchOverlay || (isTransparent ? theme.submenu : theme.nav);
    const navThemeName = searchOverlayIsOpen ? searchOverlayThemeName : theme.nav;
    const themeName = {
        nav: navThemeName,
        submenu: theme.submenu,
        searchInput: theme.searchInput || navThemeName,
        searchDialog: theme.searchDialog || theme.submenu,
        searchOverlay: searchOverlayThemeName
    };
    return {
        theme: {
            nav: themes[navThemeName].nav,
            submenu: themes[themeName.submenu].submenu,
            searchInput: themes[themeName.searchInput].searchInput,
            searchDialog: themes[themeName.searchDialog].searchDialog,
            searchOverlay: themes[themeName.searchOverlay].searchOverlay
        },
        themeName
    };
};
const hooks_useMainMenuTheme = useMainMenuTheme;
export default hooks_useMainMenuTheme;
